import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Prompt from '../../../../../Prompt/Prompt';

import {
  TXTCLI_Due_to_your_recent_activityX_y_ELL,
  TXTWCL_Deposit_another_way,
  TXTWCL_For_the_time_beingX_you_will_o_ELL,
  TXTWCL_Important_Notice
} from './RiskyInfoPrompt.messages.json';
import { infoMessage } from './RiskyInfoPrompt.scss';

interface Props {
  onclose: () => void;
}

const RiskyInfoPrompt: React.FC<Props> = ({ onclose }) => (
  <Prompt
    variant="default"
    title={{ translation: TXTWCL_Important_Notice }}
    primaryButton={{
      translation: TXTWCL_Deposit_another_way
    }}
    onClose={onclose}
  >
    <div className={infoMessage}>
      <Translation {...TXTCLI_Due_to_your_recent_activityX_y_ELL} />{' '}
      <Translation {...TXTWCL_For_the_time_beingX_you_will_o_ELL} />
    </div>
  </Prompt>
);

export default RiskyInfoPrompt;
